"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var generateFileSystemRouteTypesPlugin_exports = {};
__export(generateFileSystemRouteTypesPlugin_exports, {
  generateFileSystemRouteTypesPlugin: () => generateFileSystemRouteTypesPlugin
});
module.exports = __toCommonJS(generateFileSystemRouteTypesPlugin_exports);
var import_path = require("path");
var import_perfect_debounce = require("perfect-debounce");
var import_generateRouteTypes = require("../../typed-routes/generateRouteTypes");
var import_getRouterRootFromOneOptions = require("../../utils/getRouterRootFromOneOptions");
var import_routeFileWatch = require("../../utils/routeFileWatch");
function generateFileSystemRouteTypesPlugin(options, routeIndex) {
  var routerRoot = (0, import_getRouterRootFromOneOptions.getRouterRootFromOneOptions)(options);
  return {
    name: `one-generate-fs-route-types`,
    enforce: "post",
    apply: "serve",
    configureServer(server) {
      var _options_router_experimental, _options_router;
      var appDir = (0, import_path.resolve)(process.cwd(), (0, import_getRouterRootFromOneOptions.getRouterRootFromOneOptions)(options));
      var outFile = (0, import_path.join)(appDir, "routes.d.ts");
      var typedRoutesGeneration = ((_options_router = options.router) === null || _options_router === void 0 ? void 0 : (_options_router_experimental = _options_router.experimental) === null || _options_router_experimental === void 0 ? void 0 : _options_router_experimental.typedRoutesGeneration) || void 0;
      var generateRouteTypesDebounced = (0, import_perfect_debounce.debounce)(async function() {
        var _options_router2;
        await (0, import_generateRouteTypes.generateRouteTypes)(outFile, routerRoot, (_options_router2 = options.router) === null || _options_router2 === void 0 ? void 0 : _options_router2.ignoredRouteFiles, typedRoutesGeneration, routeIndex.getPaths());
      }, 100);
      var fileWatcherChangeListener = function(type, path) {
        if ((0, import_routeFileWatch.isRouteFileWatchEvent)({
          event: type,
          filePath: path,
          routerRoot: appDir,
          includeChangeEvents: true
        })) {
          routeIndex.update(type, path);
          return generateRouteTypesDebounced();
        }
      };
      server.watcher.addListener("all", fileWatcherChangeListener);
      return function() {
        var _options_router2;
        (0, import_generateRouteTypes.generateRouteTypes)(outFile, routerRoot, (_options_router2 = options.router) === null || _options_router2 === void 0 ? void 0 : _options_router2.ignoredRouteFiles, typedRoutesGeneration, routeIndex.getPaths());
      };
    }
  };
}
//# sourceMappingURL=generateFileSystemRouteTypesPlugin.js.map
